module.exports = __webpack_public_path__ + "static/bible-on-desk-1f471aa83c6776e0b853e753476f012b.jpg";